import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { Data2Service } from '../../data2.service';
import { UuidService } from '../../uuid.service';
import { InfoboxService } from '../../infobox/infobox.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
	selector: 'app-php-task-add',
	templateUrl: './php-task-add.component.html',
	styleUrls: ['./php-task-add.component.css'],
})
export class PhpTaskAddComponent {
	@Input() types: Array<any> = [];
	@Input() users: Array<any> = [];
	@Input() objType: number;
	@Input() objId: string;
	@Output() added = new EventEmitter();
	loader = false;
	task = {
		id: null,
		objType: null,
		objId: null,
		type: null,
		status: null,
		author: null,
		owners: null,
		deadline: null,
		content: null,
	};
	errors = {
		type: null,
		owners: null,
		deadline: null,
		content: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly uuid: UuidService,
		private readonly infobox: InfoboxService,
		private readonly auth: AuthService,
	) {
		this.task.owners = [this.auth.getUserId()];
	}

	submit(): void {
		this.loader = true;
		this.task.id = this.uuid.generate();
		this.task.objType = this.objType;
		this.task.objId = this.objId == '[auto]' ? this.task.id : this.objId;
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.task[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (hasErrors) {
			return;
		}
		this.api.post('/tasks/', this.task, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Dodano');
			this.task.owners = [this.auth.getUserId()];
			this.task.content = null;
			this.task.type = null;
			this.added.next(true);
			this.loader = false;
		});
	}
}
